// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/SubaccountsFranchises_FranchisesWithSubaccountsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /payments/accounts/franchises_with_subaccounts
 *
 * Primitive list of franchise IDs (cast to int by the model) that have
 * an active subaccount linked. dados is the array directly.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type SubaccountsFranchises_FranchisesWithSubaccountsResponseDados = number[];

export type SubaccountsFranchises_FranchisesWithSubaccountsResponse = ApiResponse<SubaccountsFranchises_FranchisesWithSubaccountsResponseDados>;

registerResponseContract('SubaccountsFranchises_FranchisesWithSubaccountsResponse', {})
